import {
  getFormValue,
  setQuestionVisibility,
  getQuotationIsFromRenewal,
  changeQuestionClearOnHide,
  getOwnerData,
  getQuotation,
  getUserData,
} from 'app/services/businessFunctionHelpers';
import { FieldsEnum, FormsEnum } from 'app/shared/enums';

const childrenDetails = {
  ownerChildrenCountChange() {
    const isOperator = getUserData().user?.operator;
    const quotation = getQuotation();
    const shouldMoveQuestionsToCheckout =
      !isOperator && !(quotation.renewal || quotation.externalRenewal);

    if (shouldMoveQuestionsToCheckout) return;

    const hasChildren = getFormValue(
      FieldsEnum.OwnerHasChildren,
      FormsEnum.CalculationForm
    );

    const oldestChildBirthYear = getOwnerData().oldestChildBirthYear;

    const ownerHasChildrenAndIsYoungerThan26 =
      hasChildren &&
      oldestChildBirthYear &&
      new Date().getFullYear() - oldestChildBirthYear <= 26;

    const isFromRenewal = getQuotationIsFromRenewal();

    if (isFromRenewal && ownerHasChildrenAndIsYoungerThan26) {
      changeQuestionClearOnHide(
        FieldsEnum.OwnerHasChildren,
        FormsEnum.CalculationForm,
        false
      );
      changeQuestionClearOnHide(
        FieldsEnum.OwnerOldestChildAge,
        FormsEnum.CalculationForm,
        false
      );

      setQuestionVisibility({
        key: FieldsEnum.OwnerHasChildren,
        visible: false,
        formName: FormsEnum.CalculationForm,
      });

      setQuestionVisibility({
        key: FieldsEnum.OwnerOldestChildAge,
        visible: false,
        formName: FormsEnum.CalculationForm,
      });
    } else {
      setQuestionVisibility({
        key: FieldsEnum.OwnerOldestChildAge,
        visible: hasChildren,
        formName: FormsEnum.CalculationForm,
      });
    }
  },
};

export default childrenDetails;
